import React, { useState,useEffect } from "react";
import Login from "../components/login/Login";
import Signup from "../components/signup/SignUp"

const AuthComponent = () => {
  const [showLogin, setShowLogin] = useState(true);
  useEffect(()=>{
    if(!sessionStorage.loginSession){
      setShowLogin(false)
    }
  },[])
  return showLogin ?<Signup setShowLogin={setShowLogin} />: (
    <Login setShowLogin={setShowLogin} />
  )
};

export default AuthComponent;
